document.addEventListener('DOMContentLoaded', function() {
  // Function to update the selling_plan input value
  function updateSellingPlanInput(value) {
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    sellingPlanInput.value = value;
  }

  // Click event for custom-selling-plans__container
  document.querySelectorAll('.custom-selling-plans__container').forEach(container => {
    container.addEventListener('click', function() {
      // Remove 'active' class from all containers
      document.querySelectorAll('.custom-selling-plans__container').forEach(c => c.classList.remove('active'));
      
      // Add 'active' class to the clicked container
      this.classList.add('active');
      
      // Check the radio button inside the clicked container
      const radioButton = this.querySelector('input[name="selling_plan_group"]');
      radioButton.checked = true;
      
      // Show or hide selling-plan-selection based on data attribute
      const sellingPlanSelection = document.querySelector('.selling-plan-selection');
      const select = sellingPlanSelection.querySelector('select[name="selling_plan_select"]');
      
      if (this.hasAttribute('data-sub-connector')) {
        sellingPlanSelection.style.display = 'flex';
        updateSellingPlanInput(this.getAttribute('data-plan-id'));
      } else {
        sellingPlanSelection.style.display = 'none';
        // Clear the selling_plan input
        updateSellingPlanInput('');
      }
      const isSubscription = this.hasAttribute('data-sub-connector');
      document.querySelectorAll('.on-page-product-options').forEach(option => {
          const oncePrice = option.querySelector('.option-extra-data__price').getAttribute('data-once-price');
          const subscriptionPrice = option.querySelector('.option-extra-data__price').getAttribute('data-subscription-price');

          const pricingSpan = option.querySelector('.pricing-inline-span');
          if (oncePrice === "" || subscriptionPrice === "") return;
          if (pricingSpan) {
              pricingSpan.textContent = isSubscription ? subscriptionPrice : oncePrice;
          }
      });
      const unitPriceSpans = document.querySelectorAll('.product__unit-price-span');
      if (unitPriceSpans && unitPriceSpans.length > 0) {
        unitPriceSpans.forEach(span => {
          const onceUnitPrice = span.getAttribute('data-once-unit-price');
          const subscriptionUnitPrice = span.getAttribute('data-subscription-unit-price');
          const amountSpan = span.querySelector('span.amount');
          
          if (!amountSpan) return;

          if (isSubscription && subscriptionUnitPrice != "") {
            amountSpan.textContent = subscriptionUnitPrice;
          } else {
            amountSpan.textContent = onceUnitPrice;
          }
        });
      }
    });
  });

  // Change event for the subscription select dropdown
  const sellingPlanSelect = document.querySelector('.selling-plan-selection select[name="selling_plan_select"]');
  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', function() {
      updateSellingPlanInput(this.value);
    });
  }

  // Initialize the selling_plan input based on the default selection
  const activeContainer = document.querySelector('.custom-selling-plans__container.active');
  const sellingPlanSelection = document.querySelector('.selling-plan-selection');
  const select = sellingPlanSelection.querySelector('select[name="selling_plan_select"]');
  
  if (activeContainer.hasAttribute('data-sub-connector')) {
    sellingPlanSelection.style.display = 'block';
    updateSellingPlanInput(select.value);
  } else {
    sellingPlanSelection.style.display = 'none';
    updateSellingPlanInput('');
  }

  const dropdownDiv = document.getElementById('selling-plan-dropdown');
    const optionsList = document.getElementById('dropdown-options');
  
    // Show or hide the dropdown options when the div is clicked
    dropdownDiv.addEventListener('click', function () {
      const isVisible = optionsList.style.display === 'block';
      optionsList.style.display = isVisible ? 'none' : 'block';
    });
  
    // Handle clicking an option
    optionsList.addEventListener('click', function (event) {
      const target = event.target;
  
      if (target.tagName === 'LI') {
        const selectedValue = target.getAttribute('data-value');
        const selectedText = target.textContent;
        const intervalText = dropdownDiv.getAttribute("data-interval-text") ?? "Intervall";
  
        // Update the visible dropdown text
        dropdownDiv.querySelector('.p-small').textContent = `${intervalText}: ${selectedText}`;
  
        // Update the selling plan input
        updateSellingPlanInput(selectedValue);
  
        // Close the dropdown
        optionsList.style.display = 'none';
  
        // Log for debugging or further processing
        console.log('Selected Value:', selectedValue);
        optionsList.style.display = optionsList.style.display === 'block' ? 'none' : 'block';
      }
    });
  
    // Close the dropdown if clicking outside
    document.addEventListener('click', function (event) {
      if (!dropdownDiv.contains(event.target)) {
        optionsList.style.display = 'none';
    }
  });
});

  
  
  
  